import { render, staticRenderFns } from "./EmbedElementPublish.vue?vue&type=template&id=4bf96500&"
import script from "./EmbedElementPublish.vue?vue&type=script&lang=ts&"
export * from "./EmbedElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./EmbedElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports